import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';

export const VisitPaymentVisitDetails = ({ visitDetails }) => {
  const { t } = useTranslation();

  const formatDateWithoutConversion = (date) => {
    if (!date) {
      return '-';
    }

    const value = String(date);
    const datePart = value.substring(0, 10);
    const timePart = value.substring(11, 16);

    if (!datePart) {
      return '-';
    }

    if (!timePart || timePart === '00:00') {
      return datePart;
    }

    return `${datePart} ${timePart}`;
  };

  const handleCancel = () => {
    if (visitDetails.cancelationUrl) {
      window.location.href = visitDetails.cancelationUrl;
    }
  };

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <Heading variant="userAccountDetailsTitle">
            {t('userAccount.visitTab.visitInfo')}
          </Heading>
        </CardHeader>

        <CardContent className="space-y-2">
          <div>
            <span>{t('userAccount.visitTab.medicalCenter')} </span>
            <span>{visitDetails.location}</span>
          </div>

          <div>
            <span>{t('userAccount.visitTab.date')} </span>
            <span>{formatDateWithoutConversion(visitDetails.date)}</span>
          </div>
        </CardContent>

        <CardFooter>
          {(!!visitDetails.paymentUrl || !!visitDetails.cancelationUrl) && (
            <div
              className="
                flex flex-col space-y-2
                sm:flex-row sm:space-y-0 sm:space-x-2
              "
            >
              {!!visitDetails.cancelationUrl && (
                <Button variant="outline" onClick={handleCancel}>
                  {t('Atšaukti užsakymą')}
                </Button>
              )}

              {!!visitDetails.paymentUrl && (
                <Button asChild>
                  <a href={visitDetails.paymentUrl}>{t('Apmokėti užsakymą')}</a>
                </Button>
              )}
            </div>
          )}
        </CardFooter>
      </Card>
    </div>
  );
};